import styled, { css } from 'styled-components'
import type { CalloutVariant } from 'sutra/components/Callout/Callout'
import { accents, gray } from 'sutra/tokens/colors'
import { radii } from 'sutra/tokens/radii'
import { typography } from 'sutra/tokens/typography'

const variantStyles: Record<CalloutVariant, ReturnType<typeof css>> = {
  info: css`
    background: ${accents.reflectionBlue[100]};
    border-color: ${accents.reflectionBlue[200]};
  `,
  success: css`
    background: ${accents.emeraldAura[100]};
    border-color: ${accents.emeraldAura[200]};
  `,
  warning: css`
    background: ${accents.goldenLight[100]};
    border-color: ${accents.goldenLight[400]};
  `,
  danger: css`
    background: ${accents.crimsonBloom[100]};
    border-color: ${accents.crimsonBloom[400]};
  `,
}

export const StyledCallout = styled.div<{
  $variant: CalloutVariant
  $roomy: boolean
}>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: ${({ $roomy }) => ($roomy ? '16px 18px' : '12px 14px')};
  border-radius: 8px;
  border: 1px solid;
  font-size: 13px;
  line-height: 1.5;
  ${({ $variant }) => variantStyles[$variant]}
`

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  padding-top: 1px;
  flex-shrink: 0;
`

export const Content = styled.div`
  flex: 1;
  min-width: 0;
`

export const Title = styled.div`
  font-weight: ${typography.weights.semibold};
  color: ${gray[900]};
`

export const Description = styled.div`
  margin-top: 2px;
  color: ${gray[700]};
`

export const Action = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  flex-shrink: 0;
`

export const DismissButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  border-radius: ${radii.xs}px;
  background: transparent;
  color: ${gray[500]};
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: ${accents.reflectionBlue[100]};
    color: ${gray[700]};
  }
`
